/**
 * Polling backoff for the job hooks. When the last fetch was rate-limited (429),
 * the client must stop polling at its normal cadence — otherwise it just feeds
 * the storm. `pollInterval` returns a long cool-off interval on a 429, and the
 * caller's desired interval otherwise (or `false` to stop).
 */
import { ApiError } from './errors'

/**
 * Base poll cadence for an active job / list, in ms. Single knob — raise to poll
 * gentler. 3s proved too chatty (tripped the rate limiter); 10s is plenty for
 * status/progress.
 */
export const POLL_ACTIVE_MS = 10_000

/** Cool-off between polls after a 429, in ms. */
export const RATE_LIMIT_BACKOFF_MS = 30_000

/** Shared React Query retry policy: client errors are not transient. */
export function shouldRetryQuery(
  failureCount: number,
  error: unknown,
): boolean {
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
    return false
  }
  return failureCount < 1
}

export function pollInterval(
  lastError: unknown,
  desired: number | false,
): number | false {
  if (lastError instanceof ApiError && lastError.status === 429) {
    return RATE_LIMIT_BACKOFF_MS
  }
  return desired
}
